export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6206.f8aca3e4.jpg";